package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import com.shepeliev.webrtckmp.AudioTrack
import kotlinx.browser.document
import org.w3c.dom.HTMLAudioElement
import com.shepeliev.webrtckmp.MediaStream as WebRtcMediaStream
import org.w3c.dom.mediacapture.MediaStream as DomMediaStream

/**
 * En web el audio remoto no suena solo: hay que adjuntar el track a un elemento de medios. Armamos
 * un [WebRtcMediaStream] con el track (API pública de webrtc-kmp) y usamos su `MediaStream` nativo
 * (`.js`) como `srcObject` de un `<audio>` oculto. No usa [HtmlElementView] porque no tiene UI.
 */
@Composable
actual fun RemoteAudioSink(audioTrack: AudioTrack?) {
    if (audioTrack == null) return

    val audioElement = remember {
        (document.createElement("audio") as HTMLAudioElement).apply {
            autoplay = true
        }
    }

    DisposableEffect(audioTrack) {
        val stream = WebRtcMediaStream().apply { addTrack(audioTrack) }
        audioElement.srcObject = stream.js.unsafeCast<DomMediaStream>()
        document.body?.appendChild(audioElement)
        runCatching { audioElement.play() }
        onDispose {
            audioElement.srcObject = null
            audioElement.remove()
        }
    }
}
